export default __webpack_public_path__ + "static/media/contact1.06965047.png";